@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';

@left-side-width: 345px;

.preview-modal {
  display: flex;
}

.preview-form {
  width: @left-side-width;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.preview-form-top {
  margin: 0 16px;
}

.input-item {
  width: 100%;
}

.preview-form-title {
  font-size: 16px;
  font-weight: @bold;
  margin: 20px 0 8px;
}

.preview-form-item-title {
  font-size: 14px;
  font-weight: @bold;
  margin: 16px 0 8px;
}

.preview-section {
  width: 700px;
  padding: 20px 16px;
  border: 1px solid @settings-page--stores-selected-checkout-preview--border-color;
  background: @settings-page--stores-selected-checkout-preview--background-color;
}

.preview-title {
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: @bold;
}

.preview-list {
  font-size: 14px;
  margin-bottom: 16px;
  font-weight: @bold;
}

.preview-description {
  line-height: 1.5;
  font-size: 14px;
  margin-bottom: 20px;
  color: @settings-page--stores-selected-checkout-preview--text-color;
}

.required-message {
  line-height: 1.5;
  font-size: 14px;
  color: @settings-page--stores-selected-checkout-preview--text-color;
}

.loading-indicator-wrapper {
  height: 80px;
  display: flex;
  justify-content: center;
}

.loading-indicator {
  height: 80px;
  width: 80px;
}

.rate {
  padding: 20px;
  border: 1px solid @settings-page--stores-selected-checkout-preview-rate--border-color;
  align-items: center;
  display: grid;
  grid-template-columns: minmax(auto, 200px) minmax(auto, 210px) 1fr auto;
  background: @settings-page--stores-selected-checkout-preview-rate--background-color;

  &:not(:first-child) {
    margin-top: 4px;
  }

  &.disabled {
    background: @settings-page--stores-selected-checkout-preview--background-color;
    color: @settings-page--stores-selected-checkout-preview--text-color;
  }
}

.radio-button-wrapper {
  margin-right: 10px;
}

.rate-info {
  flex-grow: 1;
  line-height: 1.5;
}

.rate-name {
  font-weight: @bold;
  font-size: 16px;
  margin-right: 4px;
}

.delivery-estimate-info {
  line-height: 1.5;
}
.rate-delivery-time {
  font-weight: @bold;
  font-size: 14px;
}

.rate-description {
  font-size: 14px;
  color: @settings-page--stores-selected-checkout-preview--text-color;
}

.rate-info-block {
  display: flex;
  align-items: center;
}

.rate-price {
  margin-left: 10px;
  font-weight: @bold;
  font-size: 16px;
  justify-self: end;
}

.description {
  margin-top: 20px;
  color: @settings-page--stores-selected-checkout-preview-description--text-color;
  margin-bottom: 5px;
  font-size: 14px;
}

.weight-divider {
  margin: 16px 0;
}

.preview-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: @settings-page--stores-selected-checkout-preview--background-color;
  border-top: 1px solid @settings-page--stores-selected-checkout-preview--border-color;
  margin-top: 20px;
  padding: 0 16px;
  height: 50px;
  width: @left-side-width;
}

.hidden-icon {
  color: @settings-page--stores-selected-checkout-preview-hidden--text-color;
  height: 15px;
  width: 15px;
  margin-right: 4px;
}

.check-icon {
  color: @settings-page--stores-selected-checkout-preview-check--text-color;
  height: 15px;
  width: 15px;
  margin-right: 4px;
}

.status-indicator {
  border: 1px solid @settings-page--stores-selected-checkout-preview--border-color;
  border-radius: 5px;
  background: @settings-page--stores-selected-checkout-preview--background-color;
  padding: 4px 8px;
  align-items: center;
  width: fit-content;
  font-size: 12px;
  display: flex;
}

.address-wrapper {
  display: block;
  & label {
    font-weight: @bold;
  }
  & span {
    display: none;
  }
  label + div {
    margin-bottom: 12px;
  }
  label[for='line1'] {
    & + div {
      margin-bottom: 8px;
    }
  }
  label[for='line2'] {
    display: none;
  }
}

.address-type-radio-wrapper {
  display: flex;
  > * {
    margin: 0 16px 12px 0;
    padding: 0;
  }
}
